/* guides.js: the Documentation blog (sections/guides-index, sections/guide-article).
   Hub: instant search over the section's JSON index plus Shopify predictive
   search over article bodies; type chips filtering the stages in place.
   Article: TOC + scrollspy from the body's h2/h3, rail open on desktop, code
   copy buttons, click-to-play YouTube facades, keyboard-scrollable tables. */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function say(live, msg) { if (!live) return; live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 60); }

  /* Heading ids for the TOC and for redirect anchors: lower case, accents
     stripped, every run of other characters one hyphen, 64 characters max,
     -2, -3 on repeats. The redirects pipeline must use the same rule. */
  function slug(s) {
    return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 64).replace(/-+$/, '') || 'section';
  }

  /* ================= hub search ================= */
  function initSearch(form) {
    var input = $('input[type="search"]', form), pop = $('[role="listbox"]', form), live = $('[data-gd-live]', form);
    var src = document.getElementById(form.getAttribute('data-gd-search'));
    var blogPath = (form.getAttribute('data-gd-blog') || '/blogs/docs').replace(/\/$/, '') + '/';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var data = { labels: {}, guides: [] };
    try { data = JSON.parse(src.textContent); } catch (e) {}
    var L = data.labels || {};
    var TYPES = ['getting-started', 'manual', 'pinouts', 'specifications', 'software', 'cloud', 'developer', 'video', 'faq', 'troubleshooting'];
    data.guides.forEach(function (d) { d._t = ' ' + norm(d.t); d._k = norm(d.k + ' ' + d.g); d._e = norm(d.e); });

    var opts = [], active = -1, local = [], remote = [], q = '', timer = 0, ctrl = null, uid = 0;

    function score(d, terms) {
      var s = 0;
      for (var i = 0; i < terms.length; i++) {
        var t = terms[i], hit = 0;
        if (d._t.indexOf(' ' + t) > -1) hit = 12;
        else if (d._t.indexOf(t) > -1) hit = 9;
        else if (d._k.indexOf(t) > -1) hit = 5;
        else if (d._e.indexOf(t) > -1) hit = 2;
        if (!hit) return 0;
        s += hit;
      }
      return s;
    }
    function find(query) {
      var terms = norm(query).split(/\s+/).filter(Boolean);
      if (!terms.length) return [];
      return data.guides.map(function (d) { return { d: d, s: score(d, terms) }; })
        .filter(function (x) { return x.s > 0; })
        .sort(function (a, b) { return b.s - a.s || a.d.t.localeCompare(b.d.t); })
        .slice(0, 8).map(function (x) { return x.d; });
    }
    function path(u) { try { return new URL(u, location.origin).pathname; } catch (e) { return u; } }

    function option(href, title, meta, excerpt, extra) {
      var a = el('a', 'gd-search__opt' + (extra || ''));
      a.href = href; a.id = 'gd-opt-' + (++uid); a.setAttribute('role', 'option'); a.setAttribute('tabindex', '-1'); a.setAttribute('aria-selected', 'false');
      a.appendChild(el('span', 'gd-search__t', title));
      if (meta) a.appendChild(el('span', 'gd-search__m', meta));
      if (excerpt) a.appendChild(el('span', 'gd-search__e', excerpt));
      opts.push(a);
      return a;
    }
    function group(label, items) {
      var g = el('div'), id = 'gd-grp-' + (++uid), h = el('div', 'gd-search__glabel', label);
      g.setAttribute('role', 'group'); g.setAttribute('aria-labelledby', id); h.id = id; h.setAttribute('role', 'presentation');
      g.appendChild(h);
      items.forEach(function (n) { g.appendChild(n); });
      pop.appendChild(g);
    }
    function render() {
      pop.textContent = ''; opts = []; active = -1;
      input.removeAttribute('aria-activedescendant');
      if (!q) { close(); return; }
      // an exact product name or key goes straight to that product's documentation view
      var nq = norm(q).replace(/\s+/g, ' ').trim(), jump = [];
      Object.keys(L).forEach(function (k) { if (TYPES.indexOf(k) < 0 && (norm(L[k]) === nq || k === nq)) jump.push(k); });
      if (jump.length) group('Product', jump.map(function (k) { return option(blogPath + 'tagged/product-' + k, 'All ' + L[k] + ' documentation', '', ''); }));
      if (local.length) group('Documentation', local.map(function (d) {
        var meta = [L[d.p] || '', L[d.y] || ''].filter(Boolean).join(' · ');
        return option(d.u, d.t, meta, d.e);
      }));
      if (remote.length) group('In the text', remote.map(function (r) { return option(r.url, r.title, '', ''); }));
      if (!local.length && !remote.length) pop.appendChild(el('p', 'gd-search__none', 'No guide titles match. Try the full search.'));
      var all = option(root + 'search?type=article&q=' + encodeURIComponent(q), 'Search all guides for “' + q + '”', '', '', ' gd-search__all');
      pop.appendChild(all);
      pop.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      var n = local.length + remote.length;
      say(live, n ? n + (n === 1 ? ' guide' : ' guides') + ' found' : 'No guides found');
    }
    function close() { pop.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; }
    function move(i) {
      if (!opts.length) return;
      if (active > -1) opts[active].setAttribute('aria-selected', 'false');
      active = (i + opts.length) % opts.length;
      var o = opts[active];
      o.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', o.id);
      o.scrollIntoView({ block: 'nearest' });
    }
    function fetchText(query) {
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=article&resources[options][fields]=title,body&resources[limit]=10';
      fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        if (query !== q) return;
        var seen = {};
        local.forEach(function (d) { seen[path(d.u)] = 1; });
        var arts = (j && j.resources && j.resources.results && j.resources.results.articles) || [];
        remote = arts.filter(function (a) { var p = path(a.url); return p.indexOf(blogPath) > -1 && !seen[p] && (seen[p] = 1); })
          .map(function (a) { return { url: path(a.url), title: a.title }; });
        render();
      }).catch(function () {});
    }

    input.addEventListener('input', function () {
      q = input.value.trim();
      local = find(q); remote = [];
      render();
      clearTimeout(timer);
      if (q.length > 1) timer = setTimeout(function () { fetchText(q); }, 250);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (pop.hidden && q) render(); move(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(active - 1); }
      else if (e.key === 'Home' && active > -1) { e.preventDefault(); move(0); }
      else if (e.key === 'End' && active > -1) { e.preventDefault(); move(opts.length - 1); }
      else if (e.key === 'Enter' && active > -1 && !pop.hidden) { e.preventDefault(); location.href = opts[active].href; }
      else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); input.value = ''; q = ''; local = []; remote = []; close(); }
    });
    input.addEventListener('focus', function () { if (q) render(); });
    pop.addEventListener('mousedown', function (e) { e.preventDefault(); });
    form.addEventListener('focusout', function (e) { if (!form.contains(e.relatedTarget)) close(); });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    // a search sent from the support page lands here as ?q=
    var q0 = new URLSearchParams(location.search).get('q');
    if (q0) { input.value = q0; input.dispatchEvent(new Event('input')); input.focus(); }
  }

  /* ================= article: TOC + scrollspy ================= */
  function initToc(body) {
    var list = $('[data-gd-toc]'), rail = $('[data-gd-rail]'), mq = window.matchMedia('(min-width: 1024px)');
    if (rail) {
      if (mq.addEventListener) mq.addEventListener('change', function (e) { rail.open = e.matches; });
      rail.addEventListener('click', function (e) { if (!mq.matches && e.target.closest('a[href^="#"]')) rail.open = false; });
    }
    if (!list) return;
    var hs = $$('h2, h3', body), used = {}, cur = null, links = [];
    if (!hs.length) { var blk = list.closest('[data-gd-toc-block]'); if (blk) blk.hidden = true; return; }
    hs.forEach(function (h) {
      var base = h.id || slug(h.textContent), id = base, n = 2;
      while (used[id] || (document.getElementById(id) && document.getElementById(id) !== h)) id = base + '-' + n++;
      used[id] = 1; h.id = id;
      var li = el('li'), a = el('a', '', h.textContent.replace(/\s+/g, ' ').trim());
      a.href = '#' + id; li.appendChild(a); links.push({ a: a, h: h });
      if (h.tagName === 'H3' && cur) {
        var sub = cur.querySelector('ul') || cur.appendChild(el('ul'));
        sub.appendChild(li);
      } else { list.appendChild(li); cur = li; }
    });
    // ids exist only now, so a deep link from a redirect (#section) needs a nudge
    if (location.hash.length > 1) {
      var target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (target && body.contains(target)) target.scrollIntoView();
    }
    var ticking = false;
    function offset() { return (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 64) + 32; }
    function update() {
      ticking = false;
      var top = offset(), on = links[0];
      for (var i = 0; i < links.length; i++) { if (links[i].h.getBoundingClientRect().top - top <= 0) on = links[i]; }
      links.forEach(function (x) { if (x === on) x.a.setAttribute('aria-current', 'true'); else x.a.removeAttribute('aria-current'); });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ================= article: body enhancements ================= */
  function copyText(t) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t);
    return new Promise(function (ok, no) {
      var ta = el('textarea'); ta.value = t; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy') ? ok() : no(); } catch (e) { no(e); }
      ta.remove();
    });
  }
  function enhance(body) {
    var live = $('.guide [data-gd-live]');

    $$('aside.g-callout', body).forEach(function (a) { a.setAttribute('role', 'note'); });

    $$('pre', body).forEach(function (pre) {
      var wrap = el('div', 'g-code'), btn = el('button', 'g-code__copy', 'Copy');
      btn.type = 'button';
      pre.parentNode.insertBefore(wrap, pre); wrap.appendChild(pre); wrap.appendChild(btn);
      if (pre.scrollWidth > pre.clientWidth) { pre.tabIndex = 0; pre.setAttribute('aria-label', 'Code, scrolls sideways'); }
      btn.addEventListener('click', function () {
        var code = pre.querySelector('code') || pre;
        copyText(code.textContent.replace(/\n$/, '')).then(function () {
          btn.textContent = 'Copied'; say(live, 'Code copied');
          setTimeout(function () { btn.textContent = 'Copy'; }, 2000);
        }, function () { say(live, 'Copy failed. Select the code and copy it instead.'); });
      });
    });

    $$('.g-table', body).forEach(function (t) {
      if (t.scrollWidth <= t.clientWidth + 1) return;
      var cap = t.querySelector('caption');
      t.tabIndex = 0; t.setAttribute('role', 'region');
      t.setAttribute('aria-label', (cap ? cap.textContent.trim() + '. ' : '') + 'Table, scrolls sideways');
    });
    $$('.g-figure', body).forEach(function (f) {
      if (!f.querySelector(':scope > svg') || f.scrollWidth <= f.clientWidth + 1) return;
      var svg = f.querySelector(':scope > svg'), cap = f.querySelector('figcaption');
      f.tabIndex = 0; f.setAttribute('role', 'region');
      f.setAttribute('aria-label', ((svg && svg.getAttribute('aria-label')) || (cap ? cap.textContent.trim() : 'Diagram')) + '. Scrolls sideways');
    });

  }

  /* ================= video facades: every a.g-video[data-yt] on the page =================
     A poster (i.ytimg.com) with a play button and the duration; the YouTube player loads only on
     play, from youtube-nocookie.com, one live player at a time. A poster narrower than 360px (the
     policy floor is a 200px-tall player) plays in a full-width dialog instead of in place. */
  var vPlaying = null, vDlg = null;
  function vIframe(id, label) {
    var f = el('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
    f.title = label; f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'; f.allowFullscreen = true;
    return f;
  }
  function vPoster(media, id, label, dur, onPlay) {
    var img = el('img'), btn = el('button', 'g-vframe__play');
    img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg'; img.alt = ''; img.loading = 'lazy'; img.width = 480; img.height = 360;
    btn.type = 'button'; btn.setAttribute('aria-label', 'Play video: ' + label + (dur ? ', ' + dur : ''));
    btn.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M7 5l8 5-8 5z"/></svg>';
    media.textContent = ''; media.appendChild(img); media.appendChild(btn);
    if (dur) media.appendChild(el('span', 'g-vframe__dur', dur));
    btn.addEventListener('click', onPlay);
    return btn;
  }
  function vStop() {
    if (!vPlaying) return;
    var fig = vPlaying; vPlaying = null;
    fig.classList.remove('g-vframe--playing');
    vPoster(fig._media, fig._id, fig._label, fig._dur, fig._play);
  }
  function vDialog(id, label) {
    if (!vDlg) {
      vDlg = el('dialog', 'g-vdlg');
      vDlg.innerHTML = '<div class="g-vdlg__bar"><span class="g-vdlg__title"></span><button type="button" class="g-vdlg__close">Close</button></div><div class="g-vdlg__media"></div>';
      ($('.gd') || document.body).appendChild(vDlg);
      $('.g-vdlg__close', vDlg).addEventListener('click', function () { vDlg.close(); });
      vDlg.addEventListener('close', function () { $('.g-vdlg__media', vDlg).textContent = ''; });
      vDlg.addEventListener('click', function (e) { if (e.target === vDlg) vDlg.close(); });
      vDlg.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); vDlg.close(); } });
    }
    $('.g-vdlg__title', vDlg).textContent = label;
    var m = $('.g-vdlg__media', vDlg); m.textContent = ''; m.appendChild(vIframe(id, label));
    vDlg.showModal();
  }
  function initVideos(root) {
    $$('a.g-video[data-yt]', root).forEach(function (a) {
      var id = a.getAttribute('data-yt');
      if (!/^[A-Za-z0-9_-]{6,20}$/.test(id)) return;
      var label = a.textContent.replace(/\s+/g, ' ').trim(), dur = a.getAttribute('data-dur') || '';
      var p = a.parentElement, host = (p && p.tagName === 'P' && p.textContent.trim() === a.textContent.trim()) ? p : a;
      var fig = el('figure', 'g-vframe'), media = el('div', 'g-vframe__media');
      fig.appendChild(media);
      if (!a.hasAttribute('data-nocap')) {
        var cap = el('figcaption'), link = el('a', '', label);
        link.href = a.href; cap.appendChild(link);
        cap.appendChild(el('span', 'g-vframe__note', 'Plays from YouTube'));
        fig.appendChild(cap);
      }
      host.parentNode.replaceChild(fig, host);
      fig._media = media; fig._id = id; fig._label = label; fig._dur = dur;
      fig._play = function () {
        if (media.clientWidth < 360) { vStop(); vDialog(fig._id, fig._label); return; }
        if (vPlaying !== fig) vStop();
        fig.classList.add('g-vframe--playing');
        media.textContent = ''; var f = vIframe(fig._id, fig._label); media.appendChild(f); f.focus();
        vPlaying = fig;
      };
      vPoster(media, id, label, dur, fig._play);
    });
  }



  /* ================= video decks: choosing a row swaps the featured facade and plays it ================= */
  function initDecks() {
    $$('[data-gd-deck]').forEach(function (deck) {
      var fig = $('.g-vframe', deck);
      if (!fig) return;
      var title = $('[data-gd-deck-title]', deck), dur = $('[data-gd-deck-dur]', deck), guide = $('[data-gd-deck-guide]', deck), notice = $('[data-gd-deck-notice]', deck);
      deck.addEventListener('click', function (e) {
        var row = e.target.closest && e.target.closest('[data-gd-deck-pick]');
        if (!row || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
        var id = row.getAttribute('data-yt');
        if (!/^[A-Za-z0-9_-]{6,20}$/.test(id)) return;
        e.preventDefault();
        vStop();
        fig._id = id; fig._label = row.getAttribute('data-title') || ''; fig._dur = row.getAttribute('data-dur') || '';
        if (title) title.textContent = fig._label;
        if (dur) dur.textContent = fig._dur;
        if (guide) { var gu = row.getAttribute('data-guide-url'); guide.hidden = !gu; if (gu) { guide.href = gu; guide.textContent = row.getAttribute('data-guide-title') || ''; } }
        if (notice) { var n = row.getAttribute('data-notice') || ''; notice.textContent = n; notice.hidden = !n; }
        $$('[data-gd-deck-pick]', deck).forEach(function (r) { if (r === row) r.setAttribute('aria-current', 'true'); else r.removeAttribute('aria-current'); });
        fig._play();
      });
    });
  }

  var search = $('[data-gd-search]');
  if (search) initSearch(search);
  var body = $('.guide__body');
  if (body) { enhance(body); initToc(body); }
  initVideos(document);
  initDecks();
})();
